import styled from 'styled-components';

// Container components
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AppsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// User Group Card styles
export const UserGroupContainer = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #ffffff;
  border: 1px solid #d1d5da;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e1e4e8;
`;

export const GroupLabel = styled.span`
  font-size: 0.7em;
  color: #959da5;
  letter-spacing: 0.3px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const GroupName = styled.span`
  font-weight: 700;
  font-size: 1.2em;
  color: #24292e;
`;

// App Section styles
export const AppContainer = styled.div`
  padding: 1rem 1.25rem;
  background-color: #fafbfc;
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f6f8fa;
  }
`;

export const AppHeader = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e1e4e8;
`;

export const AppLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const AppName = styled.span`
  font-weight: 700;
  color: #24292e;
  font-size: 1.05em;
`;

export const CommunityTag = styled.span`
  color: #6a737d;
  font-size: 0.8em;
  padding: 0.2rem 0.5rem;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #d1d5da;
`;

// Feature Role List styles
export const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FeatureItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 0.5rem 0;
  align-items: baseline;
`;

export const FeatureName = styled.div`
  font-weight: 500;
  color: #24292e;
  font-size: 0.95em;
`;

export const RolesText = styled.div`
  color: #586069;
  font-size: 0.95em;
  line-height: 1.5;
`;

// Empty State
export const EmptyState = styled.div`
  color: #6a737d;
  font-style: italic;
  font-size: 0.9em;
  padding: 1rem;
  text-align: center;
  background-color: #f6f8fa;
  border-radius: 4px;
  border: 1px dashed #d1d5da;
`;
